import { render, staticRenderFns } from "./AddRuleStepActionType.vue?vue&type=template&id=081b0799&"
import script from "./AddRuleStepActionType.vue?vue&type=script&lang=js&"
export * from "./AddRuleStepActionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports